module.exports = __webpack_public_path__ + "static/media/inovik.7ea059de.jpg";